<template>
  <dir class="scrollable-container">
    <v-toolbar
      :color="themeColor"
      flat>
      <span class="title">帳戶</span>
    </v-toolbar>

    <app-card-container class="flex-grow overflow-y-auto">
      <app-card title="點數">
        <v-card-text class="d-flex">
          <span>目前點數: {{profileInfo.points}}</span>
          <span>方案: 月費制</span>
        </v-card-text>
      </app-card>

      <account-teacher-profile v-if="isTeacher" />
      <account-student-profile v-if="isStudent && !isTeacher"/>

      <!-- 優惠代碼 -->
      <!-- <account-promo /> -->
    </app-card-container>
  </dir>
</template>

<script>
import {mapGetters} from 'vuex';
import AccountTeacherProfile from './AccountTeacherProfile';
import AccountStudentProfile from './AccountStudentProfile';
import AccountPromo from './AccountPromo';

export default {
  components: {
    'account-teacher-profile': AccountTeacherProfile,
    'account-student-profile': AccountStudentProfile,
    'account-promo': AccountPromo
  },

  data() {
    return {
    };
  },

  computed: {
    ...mapGetters({
      profileInfo: 'profileInfo'
    })
  },

  mounted() {
  },

  methods: {
  }
};
</script>

<style lang="stylus" scoped>

</style>
